<template>
	<div>
		<!-- <v-sheet tile height="54" class="d-flex" color="primary">
			<v-btn icon class="ma-2" @click="$refs.calendar.prev()">
				<v-icon>mdi-chevron-left</v-icon>
			</v-btn>
			<v-select v-model="type" :items="types" dense outlined hide-details class="ma-2" label="type"></v-select>
			<v-select v-model="mode" :items="modes" dense outlined hide-details label="event-overlap-mode"
				class="ma-2"></v-select>
			<v-select v-model="weekday" :items="weekdays" dense outlined hide-details label="weekdays"
				class="ma-2"></v-select>
			<v-spacer></v-spacer>
			<v-btn icon class="ma-2" @click="$refs.calendar.next()">
				<v-icon>mdi-chevron-right</v-icon>
			</v-btn>
		</v-sheet> -->

		<v-sheet tile height="64" class="d-flex" color="primary">
			<v-toolbar flat>
				<v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
					Hoy
				</v-btn>
				<v-btn fab text small color="grey darken-2" @click="prev">
					<v-icon small>
						mdi-chevron-left
					</v-icon>
				</v-btn>
				<v-btn fab text small color="grey darken-2" @click="next">
					<v-icon small>
						mdi-chevron-right
					</v-icon>
				</v-btn>
				<v-toolbar-title v-if="$refs.calendar">
					{{ $refs.calendar.title }}
				</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-menu v-if="!isMobile" bottom right>
					<template v-slot:activator="{ on, attrs }">
						<v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
							<span>{{ typeToLabel[type] }}</span>
							<v-icon right>
								mdi-menu-down
							</v-icon>
						</v-btn>
					</template>
					<v-list>
						<v-list-item @click="type = 'day'">
							<v-list-item-title>Diario</v-list-item-title>
						</v-list-item>
						<v-list-item @click="type = 'week'">
							<v-list-item-title>Semanal</v-list-item-title>
						</v-list-item>
						<v-list-item @click="type = 'month'">
							<v-list-item-title>Mensual</v-list-item-title>
						</v-list-item>
						<v-list-item @click="type = '4day'">
							<v-list-item-title>4 Días</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
			</v-toolbar>
		</v-sheet>
		<v-sheet max-height="900" min-height="600">

			<v-calendar ref="calendar" v-model="value" :weekdays="weekday" :type="type" :events="events"
				:event-overlap-mode="mode" :event-overlap-threshold="30" :event-color="getEventColor"
				@change="getTradesForCalendar" @click:event="showEvent" :weekday-format="headerDayFormat"
				:day-format="customDayFormat"></v-calendar>
			<v-overlay :value="selectedOpen" @click="selectedOpen = false">
				<v-card class="centered-card" @click.stop color="grey lighten-4" min-width="450px">
					<!-- Contenido del menú -->
					<v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x
						content-class="centered-card" offset-y>
						<v-card color="grey lighten-4" min-width="450px" flat>
							<!-- Toolbar con protección contra undefined -->
							<v-toolbar :color="selectedEvent && selectedEvent.color || 'primary'" dark>
								<v-toolbar-title>{{ selectedEvent ? selectedEvent.name : 'Evento' }}</v-toolbar-title>
								<v-spacer></v-spacer>
								<v-btn icon @click="selectedOpen = false">
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-toolbar>

							<!-- Pestañas solo si hay evento seleccionado -->
							<template v-if="selectedEvent">
								<v-tabs v-model="tab" grow>
									<v-tab>Resumen</v-tab>
									<v-tab v-if="selectedEvent.meta && selectedEvent.meta.isGrouped">Detalles</v-tab>
								</v-tabs>

								<v-tabs-items v-model="tab">
									<!-- Pestaña Resumen -->
									<v-tab-item>
										<v-card-text>
											<div v-if="selectedEvent.meta">
												<template v-if="selectedEvent.meta.isGrouped">
													<p><strong>Total trades:</strong> {{
														selectedEvent.meta.trades.length }}</p>
													<p><strong>BIDs:</strong> {{ selectedEvent.meta.bidCount }}</p>
													<p><strong>ASKs:</strong> {{ selectedEvent.meta.askCount }}</p>
												</template>
												<template v-else>
													<p><strong>Instrumento:</strong> {{ selectedEvent.meta.instrument }}
													</p>
													<p><strong>Tipo:</strong> <span
															:style="{ color: selectedEvent.meta.resultado === 'Ganadora' ? 'red' : 'green' }">{{
																selectedEvent.meta.type }}</span></p>
													<p><strong>Precio:</strong> {{ selectedEvent.meta.precio }}</p>
													<p><strong>Cantidad:</strong> {{ selectedEvent.meta.cantidad }}</p>
												</template>
											</div>
										</v-card-text>
									</v-tab-item>

									<!-- Pestaña Detalles (solo para grupos) -->
									<v-tab-item v-if="selectedEvent.meta && selectedEvent.meta.isGrouped">
										<v-card-text>
											<v-data-table :headers="headers" :items="selectedEvent.meta.trades || []"
												:items-per-page="10" dense>
												<template v-slot:item.type="{ item }">
													<span
														:style="{ color: item.resultado === 'Ganadora' ? 'red' : 'green' }">{{
															item.type
														}}</span>
												</template>
												<template v-slot:item.fecha="{ item }">
													{{ formatTime(item.fecha) }}
												</template>
											</v-data-table>
										</v-card-text>
									</v-tab-item>
								</v-tabs-items>
							</template>
						</v-card>
					</v-menu>
				</v-card>
			</v-overlay>

		</v-sheet>
	</div>
</template>

<script>
import UserService from '@/services/user.service'
// import { useDisplay } from 'vuetify'

// const { mobile } = useDisplay()

// const calendarType = computed(() => (mobile.value ? 'day' : 'month'))

export default {
	data: () => ({
		value: '',
		type: 'month',
		typeToLabel: {
			month: 'Mes',
			week: 'Semana',
			day: 'Dia',
			'4dia': '4 Dias',
		},
		// types: ['month', 'week', 'day', '4day'],
		mode: 'stack',
		modes: ['stack', 'column'],
		weekday: [0, 1, 2, 3, 4, 5, 6],
		weekdays: [
			{ text: 'Sun - Sat', value: [0, 1, 2, 3, 4, 5, 6] },
			{ text: 'Mon - Sun', value: [1, 2, 3, 4, 5, 6, 0] },
			{ text: 'Mon - Fri', value: [1, 2, 3, 4, 5] },
			{ text: 'Mon, Wed, Fri', value: [1, 3, 5] },
		],

		selectedEvent: {},
		selectedElement: null,
		selectedOpen: false,
		tab: 0
		,
		headers: [
			{ text: 'Hora', value: 'fecha', width: '100px' },
			{ text: 'Instrumento', value: 'instrument' },
			{ text: 'Tipo', value: 'type', width: '80px' },
			{ text: 'Precio', value: 'precio', width: '100px' },
			{ text: 'Cantidad', value: 'cantidad', width: '100px' }
		],
		expandedDetails: '',
		events: [],
		colors: [
			"blue",
			"indigo",
			"deep-purple",
			"cyan",
			"green",
			"orange",
			"grey darken-1",
		],
		names: [
			"Meeting",
			"Holiday",
			"PTO",
			"Travel",
			"Event",
			"Birthday",
			"Conference",
			"Party",
		],
	}),
	computed: {
		isMobile() {
			return this.$vuetify.breakpoint.smAndDown
		},
	},
	mounted() {
		if (this.isMobile) {
			this.type = 'day'
		} else {
			this.type = 'month'
		}
	},
	watch: {
		isMobile(newVal) {
			if (newVal) {
				this.type = 'day' // Forzar a día si cambia a móvil
			} else {
				this.type = 'month'
			}
		},
	},
	methods: {
		getTradesForCalendar() {
			UserService.getCalendarTrades().then(
				response => {
					// console.log(useDisplay)
					let events = [];
					// console.log('Datos recibidos:', response.data);

					if (response.data && response.data.length > 0) {
						// 1. Ordenar los datos por fecha
						response.data.sort((a, b) => new Date(a.fecha) - new Date(b.fecha));

						// 2. Agrupar trades por día
						const tradesPorDia = {};

						response.data.forEach(trade => {
							const fechaTrade = new Date(trade.fecha);
							// Normalizar la fecha (ignorar horas/minutos/segundos)
							const diaKey = new Date(fechaTrade.getFullYear(), fechaTrade.getMonth(), fechaTrade.getDate()).getTime();

							if (!tradesPorDia[diaKey]) {
								tradesPorDia[diaKey] = {
									trades: [],
									date: fechaTrade,
									bidCount: 0,
									askCount: 0
								};
							}

							tradesPorDia[diaKey].trades.push(trade);
							if (trade.type === 'BID') {
								tradesPorDia[diaKey].bidCount++;
							} else {
								tradesPorDia[diaKey].askCount++;
							}
						});

						// 3. Procesar cada día
						Object.values(tradesPorDia).forEach(dia => {
							const fechaNormalizada = new Date(dia.date);
							fechaNormalizada.setHours(12, 0, 0, 0); // Establecer a medio día para agrupados

							if (dia.trades.length <= 5) {
								// Mostrar trades individualmente (5 o menos)
								dia.trades.forEach(trade => {

									events.push({
										// name: `${trade.instrument} | ${trade.type}`,
										name: this.getTradeName(trade),
										start: new Date(trade.fecha),
										end: new Date(trade.fecha),
										// color: trade.resultado === 'Ganadora' ? 'red' : 'green',
										color: this.getTradeColor(trade), // Función para determinar el color

										meta: {
											isGrouped: false,
											instrument: trade.instrument,
											type: trade.type,
											precio: trade.precio,
											cantidad: trade.cantidad,
											resultado: trade.resultado,
											fecha: trade.fecha,
											icon: this.getTradeIcon(trade),
										}
									});
								});
							} else {
								// Mostrar evento agrupado (más de 5 trades)
								events.push({
									name: `📊 ${dia.trades.length} trades`,
									start: fechaNormalizada,
									end: fechaNormalizada,
									color: dia.bidCount > dia.askCount ? 'red' : 'green',
									meta: {
										isGrouped: true,
										trades: dia.trades, // Asegurar que sea un array
										bidCount: dia.bidCount,
										askCount: dia.askCount,
										date: fechaNormalizada.toISOString().split('T')[0]
									}
								});
							}
						});

						// 4. Ordenar eventos cronológicamente
						events.sort((a, b) => a.start - b.start);

						// console.log('Eventos generados:', events);
						this.events = events;
					} else {
						console.warn('No se recibieron datos para generar eventos');
						this.events = [];
					}

				},
				error => {
					this.content =
						(error.response &&
							error.response.data &&
							error.response.data.message) ||
						error.message ||
						error.toString();

					if (error.response && error.response.status === 403 || error.response.status === 401) {
						this.$store
							.dispatch('logout', this.user) //calls the login action and passes login info
							.then(() => this.$router.push('/')) //redirect to dash after login
							.catch((err) => {
								console.log(err)
								this.snackbar = true //shows error on wrong pass
							})
					}
				}
			);
		},
		showEvent({ nativeEvent, event }) {
			// Asegurar que el evento tenga la estructura correcta
			this.selectedEvent = {
				...event,
				meta: event.meta || {
					isGrouped: false,
					trades: [],
					bidCount: 0,
					askCount: 0
				}
			};

			this.selectedElement = nativeEvent.target;
			this.selectedOpen = true;
			this.tab = 0;
		},
		formatTime(dateString) {
			if (!dateString) return 'N/A';
			return new Date(dateString).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
		},
		getEventColor(event) {
			return event.color;
		},
		setToday() {
			this.value = ''
		},
		prev() {
			this.$refs.calendar.prev()
		},
		next() {
			this.$refs.calendar.next()
		},
		headerDayFormat(day) {
			const date = new Date(day.date)
			// Formato corto personalizado (ej: "Lun", "Mar")
			return date.toLocaleDateString(this.locale, { weekday: 'short' })
		},
		customDayFormat(day) {
			// Formato personalizado para los días
			const date = new Date(day.date)
			const options = {
				weekday: 'short',
				day: 'numeric',
				month: 'short'
			}

			// Usar toLocaleDateString con el locale configurado
			return date.toLocaleDateString(this.locale, options)

		},
		getTradeName(trade) {
			return `${trade.instrument} ${trade.type === 'BID' ? '▲' : '▼'} ${trade.precio}`;
		},
		getTradeIcon(trade) {
			if (trade.resultado !== 'Ganadora') {
				return trade.type === 'BID' ? 'mdi-arrow-up-bold' : 'mdi-arrow-down-bold';
			} else {
				return trade.type === 'BID' ? 'mdi-arrow-up' : 'mdi-arrow-down';

			}
		},
		getTradeColor(trade) {
			// Verifica si el trade es ganador o perdedor
			if (trade.resultado !== 'Ganadora') {
				return trade.type === 'BID' ? '#388E3C' : '#C62828'; // Verde oscuro para BID ganador, rojo oscuro para ASK ganador
			} else {
				return trade.type === 'BID' ? '#EF5350' : '#66BB6A'; // Rojo claro para BID perdedor, verde claro para ASK perdedor
			}

			// Alternativa más simple:
			// return trade.resultado === 'Ganadora' ? 'green' : 'red';
		},
	},
};
</script>

<style scoped>
/* Estilos para la tabla */
.v-data-table {
	font-size: 0.85rem;
}

/* Protección contra contenido vacío */
.v-card-text {
	min-height: 100px;
	display: flex;
	flex-direction: column;
}

/* Estilos para las pestañas */
.v-tab {
	min-width: 120px;
}

.v-calendar-weekly__head-weekday {
	font-size: 0.9rem;
	font-weight: 500;
	padding: 4px 0;
}

.v-calendar-weekly__day-label {
	font-size: 1.1rem;
	font-weight: bold;
}

.centered-card {
	position: fixed !important;
	top: 50% !important;
	left: 50% !important;
	transform: translate(-50%, -50%) !important;
	max-width: 80vw;
	max-height: 80vh;
	overflow-y: auto;
}

.event-item {
	padding: 2px 4px;
	border-radius: 2px;
	font-size: 0.8rem;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.event-item.ganadora {
	background-color: rgba(76, 175, 80, 0.1);
}

.event-item.perdedora {
	background-color: rgba(244, 67, 54, 0.1);
}
</style>